import React from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const PromptInput = ({ 
  inputValue, 
  onInputChange, 
  onGenerate, 
  isLoading, 
  placeholder = "Describe what you need help with... (e.g., 'Create a marketing email for a new product launch' or 'Draft a legal contract clause for data privacy')" 
}) => {
  const handleSubmit = (e) => {
    e?.preventDefault();
    if (inputValue?.trim() && !isLoading) {
      onGenerate();
    }
  };

  return (
    <div className="w-full max-w-4xl mx-auto">
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="relative">
          <Input
            type="text"
            label="What do you need help with?"
            placeholder={placeholder}
            value={inputValue}
            onChange={(e) => onInputChange(e?.target?.value)}
            className="w-full"
            description="Describe your requirements in detail for better AI-powered suggestions"
          />
        </div>
        
        <div className="flex justify-center">
          <Button
            type="submit"
            variant="default"
            size="lg"
            loading={isLoading}
            disabled={!inputValue?.trim() || isLoading}
            iconName="Sparkles"
            iconPosition="left"
            className="px-8 py-3"
          >
            {isLoading ? 'Generating Prompts...' : 'Generate Prompts'}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default PromptInput;